import { call } from 'redux-saga/effects';
import { config } from '../../../../env';
import { CustomerCareResource } from '../../core/resources/customerCare.resource';
import { customerCareSerializer } from '../../models/customerCare/customerCare.serializer';
import { IAPIResponseCustomerCare } from '../../models/customerCare/customerCare.type';

export function* getFAQLink() {
  const response: IAPIResponseCustomerCare = yield call(
    CustomerCareResource.getFAQ,
    config.env.credentials.trackId
  );

  return customerCareSerializer(response);
}
